import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {FrameViewerState} from '../../../srcCommon/inboxes/side/sideFrameActions';
import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {SidePanelTrackingPayload} from '../../helpers/sidePanelTrackingHelpers';
import {ApplicationEntryPointModel} from '../../models/api/applicationEntryPointModel';
import {AppState} from '../../store/appState';
import {getApplications} from '../../store/data/applications/applicationsSelectors';
import {getIsUserGlobalAdmin, getUser} from '../../store/data/teammates/teammatesSelectors';
import {ViewerPanelId} from '../../store/panels/panelStateBase';
import {AppEntrypointLegacySdkComponent} from './appEntryPointLegacySdkComponent';

/*
 * Props.
 */

export interface AppEntrypointLegacySdkContainerProps {
  panelId: ViewerPanelId;
  viewerState?: FrameViewerState;
  trackingPayload?: SidePanelTrackingPayload;
  entryPoint: ApplicationEntryPointModel;
  onRequestWidthChange: HandlerOf<number>;
}

/*
 * Selectors.
 */

function getApplicationId(_state: AppState, props: AppEntrypointLegacySdkContainerProps) {
  return props.entryPoint.applicationId;
}

const getApplication = createSelector([getApplications, getApplicationId], (applications, applicationId) => {
  const application = applications[applicationId];
  if (!application) {
    throw new Error('Application could not be found for entry point.');
  }

  return application;
});

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AppEntrypointLegacySdkContainerProps>()(() => ({
  user: getUser,
  application: getApplication,
  isUserGlobalAdmin: getIsUserGlobalAdmin,
}));

export const AppEntrypointLegacySdkContainer = connect(mapStateToProps)(AppEntrypointLegacySdkComponent);
